module.exports = __webpack_public_path__ + "static/img/rk-profile.d620ea5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/rk-profile.svg
// module id = omUA
// module chunks = 14